import React from "react";
import { Statistic } from "antd";
import "./index.css";

const OrderInfoStatistics = ({ data }) => {
  const dataLength = data.length;

  let delayed = 0;
  let veryLate = 0;

  for (let row of data) {
    if (row.result >= 10) {
      veryLate += 1;
    } else if (row.result > 0 && row.result < 10) {
      delayed += 1;
    }
  }

  const calculatePercents = (value, totalCount) => {
    let percents = 0;
    if (totalCount !== 0) {
      percents = Math.round((value / totalCount) * 100);
      return `${value} (${percents}%)`;
    }
    return 0;
  };

  return (
    <div className="order-info-statistics">
      <Statistic
        title={<p className="order-info-statistics-title">Доставки</p>}
        value={dataLength}
        valueStyle={{ textAlign: "center", fontSize: "18px" }}
      />
      <Statistic
        valueStyle={{ textAlign: "center", fontSize: "18px" }}
        title={
          <p className="order-info-statistics-title order-info-statistics-delay-title">
            до 10 минути
          </p>
        }
        value={calculatePercents(delayed, dataLength)}
      />
      <Statistic
        valueStyle={{ textAlign: "center", fontSize: "18px" }}
        title={
          <p className="order-info-statistics-title order-info-statistics-very-late-title">
            над 10 минути
          </p>
        }
        value={calculatePercents(veryLate, dataLength)}
      />
    </div>
  );
};

export default OrderInfoStatistics;
